import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ServiceCompany } from "../../Model/ServiceCompany/ServiceCompany";

export async function deleteServiceCompanyService(serviceCompanyServiceId) {
    let response = await getAPIResponse("/v1/service-company/" + serviceCompanyServiceId, {}, "DELETE");
    if (response === null) {
        return null;
    }
    let serviceCompany = ServiceCompany.createFormResponseData(response);
    return serviceCompany;
}